import * as Yup from 'yup';

import { UuidableName } from 'utils/api/types';
import { UsersCreationParams } from 'utils/api/modules/user/user.types';
import { EntityModules, UserRole } from 'core/constants';

export interface FormValues {
  name: string;
  email: string;
  role: string;
  productLicenses: {
    alarms: boolean;
    audits: boolean;
    events: boolean;
    documents: boolean;
    risks: boolean;
  };
  teams: UuidableName[];
  organisation: UuidableName;
}

type SchemaObject = {
  [key in keyof FormValues]: Yup.Schema;
};

const UserSchema = Yup.object().shape<SchemaObject>({
  name: Yup.string().required('Name is required'),
  email: Yup.string().email('Invalid email').required('Email is required'),
  role: Yup.string().required('Role is required'),
  productLicenses: Yup.object().shape({
    alarms: Yup.boolean(),
    audits: Yup.boolean(),
    events: Yup.boolean(),
    risks: Yup.boolean(),
  }),
  teams: Yup.array(),
  organisation: Yup.object().shape({ uuid: Yup.string(), name: Yup.string() }),
});

export const getValidationSchema = (userRole: UserRole): typeof UserSchema => {
  if (userRole === UserRole.Admin) {
    return UserSchema.shape({
      organisation: Yup.object().shape({
        uuid: Yup.string().required('Organisation is required'),
        name: Yup.string().required('Organisation is required'),
      }),
    });
  }
  return UserSchema;
};

export const initialValues: FormValues = {
  name: '',
  email: '',
  role: '',
  productLicenses: {
    alarms: false,
    audits: false,
    events: false,
    documents: false,
    risks: false,
  },
  teams: [],
  organisation: { uuid: '', name: '' },
};

export const getUserValues = (values: FormValues): UsersCreationParams => {
  const { role, email, name, productLicenses, teams, organisation } = values;

  const licenses = {
    workflows: productLicenses.audits,
    protectorNotify: false,
    protectorAlarms: productLicenses.alarms,
    [EntityModules.Events]: productLicenses.events,
    [EntityModules.RisksAssessments]: false,
    [EntityModules.Documents]: productLicenses.documents,
    [EntityModules.Risks]: productLicenses.risks,
    protectorIncidents: false,
  };

  return {
    email,
    name,
    teams: teams.map(({ uuid }) => ({ uuid })),
    licenses,
    role,
    organisation: organisation.uuid !== '' ? organisation.uuid : undefined,
  };
};
